/**
 * Порты внешнего мира для ядра софтфона.
 *
 * Ядро не знает ни про SIP.js, ни про таймеры браузера: всё, что оно трогает
 * снаружи, описано интерфейсами ниже. Благодаря этому вся логика (переподключение,
 * поддержание регистрации, ICE-сторож, машина состояний) прогоняется тестами
 * в node с фейковым стеком и управляемым временем — без браузера и без станции.
 */
/** Боевой планировщик поверх setTimeout */
export const systemScheduler = {
    schedule(fn, delayMs) {
        const id = setTimeout(fn, delayMs);
        return () => {
            clearTimeout(id);
        };
    },
    now: () => Date.now(),
    random: () => Math.random(),
};
//# sourceMappingURL=ports.js.map